export default
{
  name: 'Foundation',
  fee: 275,
  value: 'foundation',
  fullname: 'Foundation for mid-levels',
  floors: {
    1: 200,
    2: 175,
    3: 175,
    4: 175,
    5: 175,
    6: 175,
    7: 175,
    8: 150,
    9: 150,
    10: 150,
    11: 150,
    12: 150,
    13: 150,
    14: 150,
    15: 150,
    16: 150
  },
  annualFloors: {
    1: 2160,
    2: 1785,
    3: 1785,
    4: 1785,
    5: 1785,
    6: 1785,
    7: 1785,
    8: 1530,
    9: 1530,
    10: 1530,
    11: 1530,
    12: 1530,
    13: 1530,
    14: 1530,
    15: 1530,
    16: 1530
  }
}



// WEBPACK FOOTER //
// ./src/data/midlevelfees.js